/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, HostListener, OnInit } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { SessionTimerService } from './shared/service/session-timer.service';

@Component({
    selector: 'ngx-app',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(private analytics: AnalyticsService, private seoService: SeoService, private iconLibraries: NbIconLibraries, private sessionTimerService: SessionTimerService) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.sessionTimerService.startSessionTimer();
  }

  @HostListener('window:mousemove') // You can add other event listeners as needed (e.g., keypress)
  onUserActivity() {
    this.sessionTimerService.cancelSessionTimer();
    this.sessionTimerService.startSessionTimer();
  }
}
